var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdfWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 0H5.7C4.655 0 3.8 0.855 3.8 1.9V13.3C3.8 14.345 4.655 15.2 5.7 15.2H17.1C18.145 15.2 19 14.345 19 13.3V1.9C19 0.855 18.145 0 17.1 0ZM9.025 7.125C9.025 7.9135 8.3885 8.55 7.6 8.55H6.65V10.45H5.225V4.75H7.6C8.3885 4.75 9.025 5.3865 9.025 6.175V7.125ZM13.775 9.025C13.775 9.8135 13.1385 10.45 12.35 10.45H9.975V4.75H12.35C13.1385 4.75 13.775 5.3865 13.775 6.175V9.025ZM17.575 6.175H16.15V7.125H17.575V8.55H16.15V10.45H14.725V4.75H17.575V6.175ZM6.65 7.125H7.6V6.175H6.65V7.125ZM1.9 3.8H0V17.1C0 18.145 0.855 19 1.9 19H15.2V17.1H1.9V3.8ZM11.4 9.025H12.35V6.175H11.4V9.025Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdfWhite);
export default __webpack_public_path__ + "static/media/iconPdfWhite.db61edeae58b8d3d54b1ab52fc150591.svg";
export { ForwardRef as ReactComponent };